import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import toast from 'react-hot-toast';
import axios from 'axios';

const ModalNewDescuento = ({ show, handleClose }) => {
	const token = localStorage.getItem('Token');
	const config = {
		headers: {
			xtoken: `${token}`,
		},
	};

	const [formData, setFormData] = React.useState({
		nombre: '',
		descripcion: '',
		tipoDescuento: 'porcentaje',
		porcentajeDescuento: "",
		marca: '',
		tagAplicable: '',
		limiteUsos: '',
		estado: true,
	});

	const handleChange = (e) => {
		const { name, value } = e.target;
		const parsedValue = name === 'estado' ? value === 'true' : value;

		setFormData((prevData) => ({
			...prevData,
			[name]: parsedValue,
		}));
	};

	const handleSubmit = async () => {
		try {
			await axios.post(`${process.env.REACT_APP_BACK_URL}/api/descuentos`, formData, config);
			window.dispatchEvent(new Event('actualizar-descuentos'));
			toast.success('Descuento creado con éxito');
			handleClose();
			setFormData({
				nombre: '',
				descripcion: '',
				tipoDescuento: 'porcentaje',
				porcentajeDescuento: '',
				marca: '',
				tagAplicable: '',
				limiteUsos: '',
				estado: true,
			});
		} catch (error) {
			console.error(error);
			toast.error('Error al crear el descuento');
		}
	};

	return (
		<Modal show={show} onHide={handleClose}>
			<Modal.Header className='headerModalHistorial' closeButton>
				<Modal.Title>Crear nuevo descuento</Modal.Title>
			</Modal.Header>
			<Modal.Body className='modalConfirmationContainer'>
				<div className='mb-2'>
					<label>Nombre (cupón):</label>
					<input
						className='form-control'
						type='text'
						name='nombre'
						value={formData.nombre}
						onChange={handleChange}
						placeholder='Ej: LACAROJO10'
					/>
				</div>
				<div className='mb-2'>
					<label>Descripción:</label>
					<input
						className='form-control'
						type='text'
						name='descripcion'
						value={formData.descripcion}
						onChange={handleChange}
					/>
				</div>
				<div className='mb-2'>
					<label>Tipo de descuento:</label>
					<select
						className='form-control'
						name='tipoDescuento'
						value={formData.tipoDescuento}
						onChange={handleChange}
					>
						<option value='porcentaje'>Porcentaje</option>
						<option value='2x1'>2x1</option>
					</select>
				</div>
				{formData.tipoDescuento === 'porcentaje' && (
					<div className='mb-2'>
						<label>% Descuento:</label>
						<input
							className='form-control'
							type='number'
							name='porcentajeDescuento'
							value={formData.porcentajeDescuento}
							onChange={handleChange}
							min={1}
							max={100}
							placeholder='Ej: 10'
						/>
					</div>
				)}
				<div className='mb-2'>
					<label>Marca (opcional):</label>
					<input
						className='form-control'
						type='text'
						name='marca'
						value={formData.marca}
						onChange={handleChange}
						placeholder='Ej: LACA'
					/>
				</div>
				<div className='mb-2'>
					<label>Tag aplicable (opcional):</label>
					<input
						className='form-control'
						type='text'
						name='tagAplicable'
						value={formData.tagAplicable}
						onChange={handleChange}
						placeholder='Ej: brochas'
					/>
				</div>
				<div className='mb-2'>
					<label>Límite de usos (opcional):</label>
					<input
						className='form-control'
						type='number'
						name='limiteUsos'
						value={formData.limiteUsos}
						onChange={handleChange}
						min={1}
						placeholder='Ej: 100 (vacío para ilimitado)'
					/>
				</div>
				<div className='mb-2'>
					<label>Estado:</label>
					<select
						className='form-control'
						name='estado'
						value={formData.estado.toString()}
						onChange={handleChange}
					>
						<option value='true'>Activo</option>
						<option value='false'>Inactivo</option>
					</select>
				</div>

				<div className='divMagicoReset py-2 mt-4 d-flex justify-content-between'>
					<Button variant='secondary' onClick={handleClose}>
						Cerrar
					</Button>
					<Button className='botonModalConfirmacion' variant='primary' onClick={handleSubmit}>
						Guardar Descuento
					</Button>
				</div>
			</Modal.Body>
		</Modal>
	);
};

export default ModalNewDescuento;
